import { AppId } from '../helpers/restaurant.helper.types';
import { Udid } from './auth.reducer.types';
import { TimeSlot } from '../helpers/order-time.helper.types';
import { RestaurantId } from '../helpers/restaurant.helper.types';

export interface RestaurantShortInfo {
    autoMode: boolean;
    firstDeliveryTime: TimeSlot;
    firstPickupTime: TimeSlot;
    isOpen: boolean;
    isTemporaryStopOrders: boolean;
    isTooBusyForNewOrders: boolean;
    isUsingReceiptColorRotation: boolean;
    lastDeliveryTime: TimeSlot;
    lastPickupTime: TimeSlot;
    menuVersion: string;
    preOrder: boolean;
    restaurantId: RestaurantId;
    startStopTime: number;
    todaySchedule: string;
    version: number;
    isSlowService: boolean;
}

export interface MarketingConsent {
    allowEmail: boolean
    allowPush: boolean
    allowSms: true
}

export interface TermsConsent {
    status: string,
    url: string
}

export type CustomerGroupId = number;

export enum CustomerType {
    ANONYMOUS= 0,
    GUEST = 1,
    REGISTERED = 2,
}

export interface Customer {
    phone: string,
    verificationCodePhone: string,
    nickname: string,
    email: string,
    birthdate: string,
    cardNumber: string,
    hasCard: boolean,
    hasPassword: boolean,
    restaurant?: RestaurantShortInfo
    marketing: MarketingConsent,
    terms: TermsConsent,
    customerGroupIds?: Array<CustomerGroupId>,
    type: CustomerType;
}

export interface Guest {
    phone: string;
    name: string;
}

export interface Guest {
    phone: string;
    name: string;
}

export interface CustomerState {
    appId?: AppId,
    udid?: Udid,
    currentCustomer?: Customer,
    isFetchedOnce: boolean,
    isSetUAChannelIdInProgress: boolean;
    currentGuest?: Guest;
}
